import type { SVGProps } from 'react'

const CornerBottomIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5358 12.8H10.56H12.2666C12.5611 12.8 12.8 12.5612 12.8 12.2667C12.8 11.9722 12.5611 11.7333 12.2666 11.7333H10.56C9.35637 11.7333 8.48576 11.7329 7.80104 11.677C7.12255 11.6216 6.67368 11.5143 6.30505 11.3264C5.60259 10.9685 5.03145 10.3974 4.67353 9.69491C4.4857 9.32628 4.37842 8.87741 4.32298 8.19892C4.26703 7.5142 4.26662 6.6436 4.26662 5.44001V3.73335C4.26662 3.4388 4.02783 3.20001 3.73328 3.20001C3.43874 3.20001 3.19995 3.4388 3.19995 3.73335V5.44001V5.46415C3.19995 6.63851 3.19995 7.55257 3.25986 8.28578C3.32068 9.03024 3.4459 9.63511 3.72312 10.1792C4.18331 11.0824 4.91762 11.8167 5.82079 12.2768C6.36486 12.554 6.96972 12.6793 7.71418 12.7401C8.4474 12.8 9.36146 12.8 10.5358 12.8Z"
      fill="currentColor"
    />
    <path
      d="M3.73315 3.70001C3.75152 3.70001 3.76629 3.71487 3.76636 3.73322V5.44025C3.76636 6.63538 3.76696 7.53027 3.82495 8.24005C3.88291 8.94912 3.99859 9.4709 4.22827 9.92169C4.63412 10.7182 5.28131 11.3665 6.07788 11.7723C6.52877 12.002 7.05118 12.1176 7.7605 12.1756C8.47028 12.2335 9.36512 12.2332 10.5603 12.2332H12.2664C12.2846 12.2332 12.2994 12.2482 12.2996 12.2664C12.2996 12.2848 12.2847 12.2996 12.2664 12.2996H10.5359C9.35362 12.2996 8.46284 12.2999 7.75464 12.242C7.04127 12.1837 6.50941 12.0662 6.04761 11.8309C5.23866 11.4186 4.5809 10.761 4.1687 9.95197C3.93342 9.49014 3.81683 8.95835 3.75854 8.24493C3.70069 7.53673 3.69995 6.64589 3.69995 5.46368V3.73322C3.70002 3.71491 3.71485 3.70008 3.73315 3.70001Z"
      stroke="currentColor"
    />
  </svg>
)

export { CornerBottomIcon }
